/** Admin-area routes (/admin/* and /platform/*) always sign out to the platform login. */
export function loginPathFor(pathname: string): '/login/platform' | '/login' {
  return pathname.startsWith('/admin') || pathname.startsWith('/platform') ? '/login/platform' : '/login'
}
